import { render, staticRenderFns } from "./StatusOrder.vue?vue&type=template&id=e07c4526&"
import script from "./StatusOrder.vue?vue&type=script&lang=js&"
export * from "./StatusOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports